/*
 * reliq-cheat-cards.js
 * Reveals each .reliq-card when it scrolls into view by adding `.is-revealed`.
 * The element-by-element choreography (background → eyebrow → title → tagline →
 * steps → diagram) is handled in CSS via transition-delays. This file only
 * decides WHEN a card starts. Reduced-motion users get the final state at once.
 *
 */
(function () {
  'use strict';

  function revealCards() {
    var cards = document.querySelectorAll('.reliq-card');
    if (!cards.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
    );
    cards.forEach(function (c) { io.observe(c); });
  }

  function init() {
    revealCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
